import { Box, Stack, Typography } from "@mui/material";
import type { ReactNode } from "react";

import { TermHelp } from "@/components/TermHelp";

type PageHeaderProps = {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
  /** Optional glossary term key — appends an ⓘ icon after the title with hover definition. */
  helpTerm?: string;
};

export function PageHeader({ title, subtitle, actions, helpTerm }: PageHeaderProps) {
  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      spacing={2}
      alignItems={{ xs: "flex-start", sm: "center" }}
      justifyContent="space-between"
      sx={{ mb: 3 }}
    >
      <Box>
        <Stack direction="row" alignItems="center" spacing={0.5}>
          <Typography variant="h4" sx={{ fontWeight: 700 }}>
            {title}
          </Typography>
          {helpTerm && <TermHelp term={helpTerm} size="medium" />}
        </Stack>
        {subtitle && (
          <Typography variant="body1" color="text.secondary" sx={{ mt: 0.5, maxWidth: 720 }}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {actions && (
        <Stack direction="row" spacing={1} alignItems="center">
          {actions}
        </Stack>
      )}
    </Stack>
  );
}
